import { type FunctionComponent } from 'react';
import { compact, map } from 'lodash';
import { useStreetPageQuery } from '../../graphql/useStreetPageQuery';
import { StreetPageSuburbInsightsBanner } from './StreetPageSuburbInsightsBanner';
import { mapDynamicContentItem } from '../../../app-kit/components/DynamicContent/helpers/mapDynamicContentItem';
import { mapApiWeblinkVariantToLinkVariant } from '../../../app-kit/helpers/mapApiWeblinkVariantToLinkVariant';
import { mapApiWeblinkIconInfoToLinkIconInfo } from '../../../app-kit/helpers/mapApiWeblinkIconInfoToLinkIconInfo';
import { mapApiBadgeVariantToBadgeVariant } from '../../../app-kit/helpers/mapApiBadgeVariantToBadgeVariant';

export const StreetPageSuburbInsightsBannerWithData: FunctionComponent = () => {
  const { suburbInsightsBanner } = useStreetPageQuery()?.data?.streetPageBySlug ?? {};

  if (!suburbInsightsBanner) {
    return null;
  }

  const { iconInfo, callout, variant, ...rest } = suburbInsightsBanner.cta;

  return (
    <StreetPageSuburbInsightsBanner
      title={suburbInsightsBanner.title}
      insights={map(suburbInsightsBanner.insights, (insight) =>
        compact(map(insight, mapDynamicContentItem)),
      )}
      cta={{
        ...rest,
        variant: mapApiWeblinkVariantToLinkVariant(variant),
        ...(iconInfo && { iconInfo: mapApiWeblinkIconInfoToLinkIconInfo(iconInfo) }),
        ...(callout && {
          callout: { ...callout, variant: mapApiBadgeVariantToBadgeVariant(callout.variant) },
        }),
      }}
      disclaimerText={suburbInsightsBanner.disclaimerText}
    />
  );
};
